<div class="space-y-6">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold text-gray-900">Billing</h1>
    <app-button variant="primary" (clicked)="openAddModal()">
      <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      New Bill
    </app-button>
  </div>

  <div class="card overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Bill Number</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Patient</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Due Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          @if (bills().length === 0) {
            <tr>
              <td colspan="7" class="px-6 py-8 text-center text-gray-500">No bills found</td>
            </tr>
          } @else {
            @for (bill of bills(); track bill.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ bill.billNumber }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ bill.patientName }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ bill.date | date:'shortDate' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ bill.dueDate | date:'shortDate' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ bill.total | currency:'USD':'symbol':'1.2-2' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full"
                        [ngClass]="{
                          'bg-yellow-100 text-yellow-800': bill.status === 'Pending',
                          'bg-green-100 text-green-800': bill.status === 'Paid',
                          'bg-red-100 text-red-800': bill.status === 'Overdue'
                        }">
                    {{ bill.status }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  @if (bill.status === 'Pending') {
                    <app-button variant="success" (clicked)="markAsPaid(bill)" class="mr-4">Mark Paid</app-button>
                  }
                  <button (click)="openEditModal(bill)" class="text-primary-600 hover:text-primary-900 mr-4">View</button>
                  <app-button variant="danger" (clicked)="deleteBill(bill.id)">Delete</app-button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  @if (showModal()) {
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="p-6 border-b">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ editingBill() ? 'Edit Bill' : 'New Bill' }}
          </h2>
        </div>
        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Patient</label>
            <select [(ngModel)]="billForm().patientId" (change)="onPatientSelect($any($event.target).value)" class="input-field">
              <option value="">Select Patient</option>
              @for (patient of patients(); track patient.id) {
                <option [value]="patient.id">{{ patient.firstName }} {{ patient.lastName }}</option>
              }
            </select>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <app-input
                label="Bill Number"
                type="text"
                [(ngModel)]="billForm().billNumber"
                [disabled]="true">
              </app-input>
            </div>
            <div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input type="date" [value]="billForm().date ? (billForm().date | date:'yyyy-MM-dd') : ''" 
                     (input)="onDateChange(($any($event.target)).value)" class="input-field" />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Due Date</label>
              <input type="date" [value]="billForm().dueDate ? (billForm().dueDate | date:'yyyy-MM-dd') : ''" 
                     (input)="onDueDateChange(($any($event.target)).value)" class="input-field" />
            </div>
            </div>
          </div>
          <div>
            <div class="flex items-center justify-between mb-2">
              <label class="block text-sm font-medium text-gray-700">Items</label>
              <button (click)="addBillItem()" class="text-sm text-primary-600 hover:text-primary-700">+ Add Item</button>
            </div>
            @for (item of billForm().items; track $index) {
              <div class="border rounded-lg p-4 mb-3 space-y-3">
                <div class="grid grid-cols-4 gap-3">
                  <div class="col-span-2">
                    <label class="block text-xs font-medium text-gray-700 mb-1">Description</label>
                    <input type="text" [(ngModel)]="item.description" class="input-field text-sm" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Quantity</label>
                    <input type="number" [(ngModel)]="item.quantity" (input)="calculateTotal()" class="input-field text-sm" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Unit Price</label>
                    <input type="number" [(ngModel)]="item.unitPrice" (input)="calculateTotal()" class="input-field text-sm" />
                  </div>
                </div>
                @if (billForm().items!.length > 1) {
                  <app-button variant="danger" size="sm" (clicked)="removeBillItem($index)">Remove</app-button>
                }
              </div>
            }
          </div>
          <div class="border-t pt-4 space-y-2">
            <div class="flex justify-between">
              <span class="text-sm text-gray-700">Subtotal:</span>
              <span class="text-sm font-medium">{{ billForm().subtotal | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-sm text-gray-700">Tax (10%):</span>
              <span class="text-sm font-medium">{{ billForm().tax | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-sm text-gray-700">Discount:</span>
              <input type="number" [(ngModel)]="billForm().discount" (input)="calculateTotal()" class="w-24 input-field text-sm" />
            </div>
            <div class="flex justify-between text-lg font-bold border-t pt-2">
              <span>Total:</span>
              <span>{{ billForm().total | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </div>
        </div>
        <div class="p-6 border-t flex justify-end space-x-3">
          <app-button variant="secondary" (clicked)="closeModal()">Cancel</app-button>
          <app-button variant="primary" (clicked)="saveBill()">Save</app-button>
        </div>
      </div>
    </div>
  }
</div>

